export const BASE_URL = import.meta.env.VITE_BASE_URL || "";
export const API_URL = import.meta.env.VITE_API_URL || "";
export const GLOBAL_API = import.meta.env.VITE_GLOBAL_API || "";
export const JSON_URL = import.meta.env.VITE_JSON_URL || "";
export const IMAGES_URL = import.meta.env.VITE_IMAGES_URL || "";
export const GAME_ID = import.meta.env.VITE_GAME_ID || "";
export const MLB_PLAYER_AVATAR_IMAGES = import.meta.env.VITE_MLB_PLAYER_AVATAR_IMAGES || "";
export const MLB_PLAYER_SHOT_IMAGES = import.meta.env.VITE_MLB_PLAYER_SHOT_IMAGES || "";
export const MLB_PLAYER_FULL_IMAGES = import.meta.env.VITE_MLB_PLAYER_FULL_IMAGES || "";
export const STORAGE_VERSION = 1;
export const IS_LOC = window.location.href.includes(".loc");
export const IS_BACKDOOR = JSON.parse(import.meta.env.VITE_IS_BACKDOOR || "false") as boolean;
export const SKIP_ERROR_CHECKING = import.meta.env.VITE_SKIP_ERROR_CHECKING === "true";
export const BASE_DOMAIN = import.meta.env.VITE_BASE_DOMAIN || "";
export const IS_PROD = import.meta.env.VITE_ENVIRONMENT === "production";
export const IS_SECRET = import.meta.env.VITE_IS_SECRET === "true";
export const SENTRY_DSN_URL = import.meta.env.VITE_SENTRY_DSN_URL;
export const INSIGHTS_VIEW_URL = import.meta.env.VITE_INSIGHTS_VIEW_URL || "";
export const SENTRY_PROJECT_NAME = import.meta.env.VITE_SENTRY_PROJECT_NAME || "";
